import type { ReactNode } from "react";
import { useCardContext } from "../../context/CardContext";
import { FINISHES_STEP_IDENTIFIER } from "../Form/Steps/Finishes";

export function BackButton({ identifier, children }: { identifier: string; children: ReactNode }) {
	const { navigateToCard } = useCardContext();

	return (
		<button
			type="button"
			className="cursor-pointer appearance-none text-left text-primary-medium hover:underline focus:outline-none focus-visible:underline motion-safe:transition"
			onClick={() => navigateToCard(FINISHES_STEP_IDENTIFIER, identifier, true)}
		>
			{children}
		</button>
	);
}
